<template>
  <div class="popup" v-cloak v-if="idlingShow">
      <div class="content" id="idlingRealTime">
            <div class="title" style="paddingLeft:10px;">{{$t('language.paySystem.Notice')}}
                 <div class="icon white-close dialog-close" @click="close()"></div>
            </div>
            <div class="idling-body">
                   <div class="idling-info">
                       {{$t('language.cloudSync.bePaused')}}
                   </div>
                   <div class="realtime-idling-bottom">
                        <div class="icon-util " style="float:left;marginRight:5Px;position:relative;top:1Px;" :class="isSelected?'check-small':'noIdlingcheck-small'" @click.stop="checkBox()"></div>
                       <div style="float:left">{{$t('language.cloudSync.dontShow')}}</div>
                        <button style="width:110Px;float:right;" @click.stop="sureTasK()"> {{$t('language.common.ok')}}</button>
                   </div>
            </div>
      </div>
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    data:function(){
        return{
            idlingShow:false,
            isSure:false,
            isSelected:false,
            addData:null,
        }
    },
    methods: {
        close(){
          this.idlingShow=false;
          this.$parent.addTaskFlag=true;
        },
        runTasK(){
           this.idlingShow=false;
           this.isSure=true;
           this.$parent.$refs.syncAimsDialog.syncAimSubmit();
            setTimeout(()=>{
           this.$parent.syncNow();
           },600);
        },
        checkBox(){
           
            if(this.isSelected){
            this.isSelected = false;
            }else{
             this.isSelected = true;
            }
          
           // console.log(this.isSelected);
        },
        sureTasK(){
            this.idlingShow =false;
            let that = this;
            var user = commonUtils.getUser();
            localStorage.setItem(user.id+'check',this.isSelected);
            that.$parent.loading = true;
            this.Utils.doRealtimeSyncRequest('create', this.addData).then(res => {
			that.$parent.addTaskFlag = true;
				if (res.message == 'success') {
                     res.tasks[0].status= res.status;
				     taskListUtils.exeSuccessEnd('syncFlow', 'taskList', res.tasks,  that.$parent);
				} else if(res.reason=="CharacterLimit"){
                                     that.$parent.loading = false;
									 that.$parent.$toast({
										text:  this.$t('language.cloudExploer.'+res.reason),
										type: 'fail',
										idValue: "cloudSync"
									});
                }else{
									 that.$parent.loading = false;
									 that.$parent.$toast({
										text:  this.$t('language.exception.'+res.reason),
										type: 'fail',
										idValue: "cloudSync"
									});
								}
							});
        }

    },
    
}
</script>

<style>
#idlingRealTime{
    width: 560Px;
    height: 220Px;
}
.idling-body{
    width: 100%;
    height: 180Px;
    padding: 20Px 10Px 10Px 10Px;
    box-sizing: border-box;
    text-align: left;
  
}
.idling-info{
    width: 100%;
    height:100Px;
    float: left;
}
.realtime-idling-bottom{
    width: 528Px;
    height: 40Px;
    float: left;

}
.noIdlingcheck-small {
    width: 15px;
    /*no*/
    height: 15px;
    /*no*/
    background-position: -20px -208px;
    /*no*/
}

.check-small {
    width: 15px;
    /*no*/
    height: 15px;
    /*no*/
    background-position: -88px -208px;
    /*no*/
}
</style>


// WEBPACK FOOTER //
// src/components/popup/cloud_transfer_popups/idling_popup.vue